import { useQuery } from 'react-query';

import { getObjectDocs } from 'api/objectDocs/getObjectDocs';

export const useGetObjectDocs = (slug: string) => {
  const { data, refetch, isLoading } = useQuery('objectDocs', () => getObjectDocs(slug), {
    enabled: !!slug,
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading };
};

export default useGetObjectDocs;
